import styled from '@emotion/styled';
import type { Chat, Quant } from '@trinity/chat';
import { TextQueryHint } from '../../presentation/Message.QueryHint';

type BacktrackButtonProps = {
  quants: Quant[];
  onClick: () => void;
};

export const BacktrackButton = ({ quants, onClick }: BacktrackButtonProps) => {
  if (!quants || quants.length === 0) {
    return null;
  }

  return (
    <Backtrack>
      <TextQueryHint
        key={'backtrack-to-show-quant'}
        value="Didn't find what you need? Browse other analysis tabs"
        onClick={onClick} />
    </Backtrack>
  );
};

const Backtrack = styled.div`
  margin-top: 10px;
`;